import {Component, EventEmitter, Input,OnChanges, Output} from '@angular/core';
import { IUserJob } from '../core/IUserJob';
import { AIJobsService } from '../ai-jobs.service';


@Component({
    selector: 'ai-jobs-list',
    templateUrl: 'ai-jobs-list.component.html',
    styleUrls: ['ai-jobs-list.component.scss']    
    
})
export class AIJobsListComponent  implements OnChanges  {
  @Input() userJobs: Array<IUserJob>;
  @Input() currentUserJob: IUserJob;
  @Output() onSetUserJob = new EventEmitter<IUserJob>();

  public searchValue: string;
  public selectedJob: IUserJob;

  constructor(private _AIjobsService: AIJobsService) {

  }
   ngOnChanges() {
    if (this.currentUserJob)
      this.setCurrentJob(this.currentUserJob);
  }
  
  public setCurrentJob(job: IUserJob) {    
    this.selectedJob = job;
    this.onSetUserJob.emit(job);
  }

  isNextRuntimeYear9999(userJob: any): boolean {
    const nextRuntime = new Date(userJob.nextRuntime);
    return nextRuntime.getFullYear() === 9999;
  }

  shouldShowDateSection(userJob: IUserJob): boolean {
    return !this.isNextRuntimeYear9999(userJob) || userJob.rescheduleJob;
  }
}
